import { render } from "./AdvisorCard.vue?vue&type=template&id=6c591821&scoped=true"
import script from "./AdvisorCard.vue?vue&type=script&lang=js"
export * from "./AdvisorCard.vue?vue&type=script&lang=js"

import "./AdvisorCard.vue?vue&type=style&index=0&id=6c591821&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c591821"]])

export default __exports__